import ResourceApi from './ResourceApi';

const responseHandler = (response) => {
  // Avoids accessing undefined properties
  if (response) {
    if (response.data) {
      return response.data;
    }
    return response;
  }
  return response;
};

const ResourceProvider = (path) => ({
  url: path,
  /* eslint-disable no-return-await */
  index: async (params = {}) => (await ResourceApi.get(path, params).then(responseHandler)),
  post: async (payload = {}) => (await ResourceApi.post(path, payload).then(responseHandler)),
  get: async (id, params = {}) => (await ResourceApi.get(`${path}/${id}`, params).then(responseHandler)),
  put: async (id, payload = {}) => (await ResourceApi.put(`${path}/${id}`, payload).then(responseHandler)),
  delete: async (id) => (await ResourceApi.destroy(`${path}/${id}`).then(responseHandler)),
  /* eslint-enable no-return-await */
});

export default ResourceProvider;
